export default class CommissionRule {
  constructor(obj) {
    this.id = obj.id ? obj.id : 0;
    this.ratePlanId = obj.ratePlanId ? obj.ratePlanId : 0;
    this.dealerLevelID = obj.dealerLevelID ? obj.dealerLevelID : 0;
    this.description = obj.description ? obj.description : "";
    this.amount = obj.amount ? obj.amount : 0.0;
    this.fixed = obj.fixed ? obj.fixed : true;
    this.chargeTypeId = obj.chargeTypeId ? obj.chargeTypeId : 0;
    this.handsetOverride = obj.handsetOverride ? obj.handsetOverride : 0.0;
    this.dealerTypeID = obj.dealerTypeID ? obj.dealerTypeID : 0;
    this.categoryId = obj.categoryId ? obj.categoryId : 0;
  }
}
